import { DatePipe } from '@angular/common';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { RegistrationService } from 'src/app/shared/services/registration.service';
import { environment } from 'src/environments/environment';
import * as uuid from 'uuid';
declare let $: any;
@Component({
  selector: 'app-consultation-link-with-abha',
  templateUrl: './consultation-link-with-abha.component.html',
  styleUrls: ['./consultation-link-with-abha.component.css']
})
export class ConsultationLinkWithAbhaComponent implements OnInit {
  @Input() data: any;
  @Input() hiType: any;
  @Input() vitalsData: any;
  @Input() title: string = '';
  abhaNumber:any='';
  respData: any;
  modesData: any=[];
  verifyMthd: string;
  isDemoGraphic: boolean;
  isDemoGraphicM: boolean;
  showfrgtBtn: boolean;
  isForgotMob: boolean;
  selectedMode:any = '';
  respGetCareContextData: any;
  verifyotp:any=null;
  name:any='';
  demographicMobile:any;
  gender:any;
  dob:any;
  max_date = new Date(new Date().setFullYear(+`${new Date().getFullYear() - 21}`));
  demographicForm: FormGroup;
  mobPtrn = ''; mobErrMsg = ''; maxLngth = '';
  submitted = false;
  public showPassword: boolean;
  public showPasswordOnPress: boolean;
  genderList:any=[{'gender_id':'M' ,'gender_name':'Male'}
,{'gender_id':'F' ,'gender_name':'Female'}
,{'gender_id':'O' ,'gender_name':'Transgender'}];
  isAdhaarOtp: boolean;
  directAuthCallback: boolean;
  isPassword: boolean;
  verifyPswd: any=null;
  dgName:any='';
  dgGender:any='';
  dgDob:any='';
  dgMobile:any='';
  demographyData: any=null;
  isCallbackRespAvail: boolean;
  modesRetry: boolean;
  hitMobileOtp: boolean;
  legacy:any=null;
  service:any=null;
  previousResponse: any;
  hfr_code: any=[];
  doctorDetails: any=[];
  transactionId: any;
  isDisable: boolean;
  labDetails: any=[];
  interactionId: any;
  beneficiary_id: any;
  webURL: any;
  linkToken: any;
  apiCallCount = 0;
completedApiCount = 0;
  displayDate: any;
  benificiary_Name: any;
  patientName: any;
  patient_gender: any;
  patient_birth_year: any;
  constructor(public activeModal: NgbActiveModal,private datePipe: DatePipe,private formBuilder: FormBuilder
    , private modalService: NgbModal,private authServ: AuthenticationService
    , private toastr: ToastrService, private http: HttpClient , private spinner : NgxSpinnerService
    , private sanitizer: DomSanitizer, private registrationService:RegistrationService) { }

  ngOnInit(): void {
    if(sessionStorage.logUsrRoleId=='7'){
      this.doctorDetails=JSON.parse(sessionStorage.getItem('DoctorDetails')).doctor_hospitals
      this.hfr_code= this.doctorDetails[0].hfr_code
      this.interactionId=this.data.patient_interaction_id || this.vitalsData?.id
      this.beneficiary_id = this.data?.is_self ? (this.data?.beneficiary_id || this.data?.id ): (this.data?.dependent_id || this.data?.id)
      this.displayDate = this.data?.visit_date || this.data.created_on
      this.benificiary_Name = this.divideName(this.data?.is_self ? this.data.beneficiary_first_name + '' +this.data.beneficiary_middle_name+ '' + this.data.beneficiary_last_name : this.data?.dependent_name || this.data?.fullname || this.data?.patient_name)
      this.patientName = this.data?.beneficiary_first_name + ' ' +this.data?.beneficiary_middle_name+ ' ' + this.data?.beneficiary_last_name
      this.patient_gender = this.setGender(this.data?.beneficiary_gender_id)
      this.patient_birth_year = this.data?.birth_year

      if(this.hiType === 'Invoice'){
        this.beneficiary_id = this.data?.beneficiary_id
        this.benificiary_Name = this.divideName(this.data?.name)
        this.patientName = this.data?.name
        this.patient_gender = this.setGender(this.data?.beneficiary_gender_id)
        this.patient_birth_year = this.data?.birth_year
        this.interactionId = this.data?.invoice_no
        this.patient_birth_year = this.data?.birthyear

      }
      if(this.hiType === 'HealthDocumentRecord'){
        this.beneficiary_id = this.data?.beneficiary_id
        this.benificiary_Name = this.divideName(this.data?.patient_name)
        this.displayDate = this.data?.created_on
        this.interactionId=this.data?.carecontext_reference_number
        this.patientName = this.data?.beneficiary_first_name + ' ' +this.data?.beneficiary_middle_name+ ' ' + this.data?.beneficiary_last_name
        this.patient_gender = this.setGender(this.data?.beneficiary_gender_id)
        this.patient_birth_year = this.data?.birth_year
      }
      if(this.hiType === 'ImmunizationRecord'){
        this.beneficiary_id = this.data?.beneficiary_id
        this.benificiary_Name = this.divideName(this.data?.patient_name)
        this.displayDate = this.data?.visit_date
        this.interactionId = this.data?.carecontexts_referencenumber
        this.patientName = this.data?.patient_name
        // ImmunizationRecord always belongs to the beneficiary — use beneficiary_gender_id directly
        this.patient_gender = this.setGender(this.data?.beneficiary_gender_id)
        this.patient_birth_year = this.data?.birth_year
      }
      if(this.hiType === 'WellnessRecord'){
        // console.log('wellnes',this.data)
        // console.log('wellnes',this.vitalsData)
        this.beneficiary_id = this.vitalsData?.beneficiary_id
        this.benificiary_Name = this.divideName(this.data?.fullname)
        this.displayDate = this.data?.created_on
        this.interactionId = this.vitalsData?.carecontexts_referencenumber
        this.patientName = this.data?.fullname
        // ImmunizationRecord always belongs to the beneficiary — use beneficiary_gender_id directly
        this.patient_gender = this.setGender(this.data?.gender_id)
        this.patient_birth_year = this.getYear(this.data?.birth_date)
      }
    }
    if(sessionStorage.logUsrRoleId=='5'){
      this.labDetails=JSON.parse(sessionStorage.getItem('labDetails'))
      this.hfr_code= this.labDetails[0].facility_id
      this.interactionId=this.data.bill_no
      this.beneficiary_id=this.data.patient_id
      this.displayDate = this.datePipe.transform(this.data?.test_completion_time , 'dd-MM-yyyy')
      this.benificiary_Name = this.divideName(this.data?.is_self ? this.data.beneficiary_first_name + '' +this.data.beneficiary_middle_name+ '' + this.data.beneficiary_last_name : this.data?.dependent_name || this.data?.fullname || this.data?.patient_name)
      this.patientName = this.data?.beneficiary_first_name + ' ' +this.data?.beneficiary_middle_name+ ' ' + this.data?.beneficiary_last_name
      this.patient_gender = this.setGender(this.data?.beneficiary_gender_id)
       this.patient_birth_year = this.data?.birth_year
    }
  
    if(this.hfr_code === null || this.hfr_code === '' || this.hfr_code === undefined){
      this.toastr.error("This User does not Have Facilty id")
      return

      }
    this.authServ.mobPtrnSubject.subscribe(s => this.mobPtrn = s), 
    this.authServ.mobErrMsgSubject.subscribe(s => this.mobErrMsg = s),
    this.authServ.maxLngthSubject.subscribe(s => this.maxLngth = s), this.initFormControls();
    if(this.data.health_id!==null){
      this.abhaNumber=this.data.health_id;
      
      this.getLinkToken(this.beneficiary_id,this.hfr_code,this.data)
      // this.existhealthID(); //V0.5
    
    }   
  }
  onChk(check:any,text:any){
    if(check){
      if(text==='legacy'){
        this.legacy=true;
      }else if(text==='service'){
       this.service=true;
      }
    } else{
      if(text==='legacy'){
        this.legacy=false;
      }else if(text==='service'){
      this.service=false;
      }
    }
 
  }
  initFormControls() {
    this.demographicForm = this.formBuilder.group({
      name: ['', Validators.required],
      birth_date: ['', Validators.required],
      gender_id: ['', Validators.required],
      mobile: ['', [Validators.required, Validators.minLength(+this.maxLngth), Validators.pattern(this.mobPtrn)]],
     
    });
  }
  get f() { return this.demographicForm.controls; }

closeModal() {
  this.activeModal.close('changes saved');
}

getYear(date: string): number {
  return new Date(date).getFullYear();
}

  

  getLinkToken(patId,hfrId,patData){
     this.registrationService.get(`abha/hip-initiated-linking/getlinktoken/${patId}/${hfrId}`).subscribe(res => {
   if(res.status==='OK'){
    if(res.data === null){
      this.getGenerateToken(patId,hfrId,patData)
    } else{
      this.toastr.success("Link Generated");
      this.linkToken = res.data?.linkToken
      if(res.data?.linkToken){
        this.getLinkCareContext(hfrId)
            
      }
      return;
    }
    
   } else {
     this.toastr.error(res.message);
   }
   
},(err:HttpErrorResponse)=>{
  this.toastr.error(err.message)});
  }
  setGender(beneficiary_gender_id: any): string {
    if (beneficiary_gender_id == 1) return 'M';
    if (beneficiary_gender_id == 2) return 'F';
    if (beneficiary_gender_id == 3) return 'O';
    return 'M'; // safe fallback — never returns undefined
  }

  removeHyphen(value: string): string {
  return value.replace(/-/g, '');
}

  getGenerateToken(patId,hfrId,data){
    
     const uuId = uuid.v4();
     let patName :any
     let patGender :any
     let year :any
   let abhanumber =  this.removeHyphen(data.health_id_number) 
   console.log('abhanumber',abhanumber)

     // For hiTypes that always belong to the beneficiary (ImmunizationRecord, HealthDocumentRecord, etc.)
     // is_self may be undefined — fall back to the already resolved patient_gender/patientName
     if(data.is_self === true){
       patName = this.patientName
       patGender = this.patient_gender
       year = this.patient_birth_year
     } else if(data.is_self === false){
       patName = data.dependent_name
       patGender = this.setGender(data.dependent_gender_id)
       year = data.birth_year
     } else {
       // is_self is undefined (e.g. ImmunizationRecord) — use already resolved values
       patName = this.patientName
       patGender = this.patient_gender
       year = this.patient_birth_year
     }

    let payload =
    {
    "requestId":uuId,
  "abhaNumber":abhanumber,
  "abhaAddress": data.health_id,
  "name": patName,
  "gender": patGender,
  "yearOfBirth": year
}

  this.registrationService.post(`abha/m2/v3/v3-generate-link-token?hip-id=${hfrId}`,payload).subscribe({
      next: res => {
        if (res.status == 'OK') {
        //  this.respData = res.data
         if(res.data){
          this.toastr.info("Please Wait a Second"); setTimeout(() => this.toastr.clear(), 3000);

          setTimeout(() => {
           this.getModes(res.data,hfrId);
           this.toastr.success(`Your RequestId : ${res.data}`) 
          }, 3000);
         
         }

        } else {
          let errMsg: string = res.message;
          this.toastr.error(errMsg);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message);

      },
      complete: () => {
        // Any additional logic after patching values
      },
    });

  }

   getModes(requestId,hfrId){   // v3 changes

   this.registrationService.get(`registration/milestone2/getCallBack?requestId=${requestId}&api-type=ONLINK`).subscribe(res => {
      if(res.status==='OK'){
        // this.toastr.success(res.message);
        if(res.data.response && res.data.response!==null){
          this.linkToken =  res.data?.response?.linkToken
          setTimeout(() => {
              if( this.linkToken){
            this.getLinkCareContext(hfrId)
            if(this.hiType === 'Prescription'){
              this.getLinkCareContext1(hfrId)
            }
            
          }
          }, 100);
         

        }else{
          this.toastr.error('No response received from ABDM service.');
        }
        
        // this.initCallback();
        this.modesData.push('DIRECT');
      } else {
        this.toastr.error(res.message);
        this.modesData=[];
        this.modesData.push('DIRECT');
      }
    
      
   },(err:HttpErrorResponse)=>{
    this.toastr.error(err.message)});
  }


divideName(fullName: string) {
  if(fullName){
 const parts = fullName.trim().split(/\s+/);

  let firstName = '';
  let middleName = '';
  let lastName = '';

  if (parts.length === 1) {
    firstName = parts[0];
  } else if (parts.length === 2) {
    firstName = parts[0];
    lastName = parts[1];
  } else {
    firstName = parts[0];
    lastName = parts[parts.length - 1];
    middleName = parts.slice(1, parts.length - 1).join(' ');
  }

  return `${firstName}-${middleName}-${lastName}`
  }
 
}

  getLinkCareContext(hfrId){ //v3
     const uuId = uuid.v4();
    let payload =
    {
    "requestId": uuId,
    "abhaNumber": this.removeHyphen(this.data?.health_id_number),
    "abhaAddress":this.data?.health_id,
    "token": this.linkToken,
    "patient": [{
        "referenceNumber": this.beneficiary_id ,
        "display": this.benificiary_Name,
        "hiType":this.hiType,
        "count":1,
        "careContexts": [
            {
                "referenceNumber": this.interactionId,
                "display": this.displayDate
            }
        ]
 } ]
}


  this.registrationService.post(`abha/m2/v3/link/carecontextv3?hip-id=${hfrId}`,payload).subscribe({
      next: res => {
        if (res.status == 'OK') {
          this.toastr.info("Please Wait a Second"); setTimeout(() => this.toastr.clear(), 3000);
          if(res.data){
            setTimeout(() => {
              if(this.hiType === 'Prescription'){
                 this.getcarecontextCallback(res.data)
                 this.getLinkCareContext1(hfrId)
              }else{
                this.getcarecontextCallback(res.data)
              }
             
            }, 3000);
        
          // this.toastr.success(res.message)
          }

       

        } else {
          let errMsg: string = res.message;
          this.toastr.error(errMsg);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message);

      },
      complete: () => {
        // Any additional logic after patching values
      },
    });

  }
  getLinkCareContext1(hfrId){ //v3
    this.hiType ='OPConsultation';
     const uuId = uuid.v4();
    let payload =
    {
    "requestId": uuId,
    "abhaNumber": this.removeHyphen(this.data?.health_id_number),
    "abhaAddress":this.data?.health_id,
    "token": this.linkToken,
    "patient": [{
        "referenceNumber":this.beneficiary_id,
        "display": this.data?.is_self ? this.data.beneficiary_first_name + '-' +this.data.beneficiary_middle_name+ '-' + this.data.beneficiary_last_name :  this.divideName(this.data?.dependent_name || this.data?.fullname || this.data?.patient_name),
        "hiType":this.hiType,
        "count":1,
        "careContexts": [
            {
                "referenceNumber": this.data?.op_consultation_number,
                "display": this.displayDate
            }
        ]
 } ]
}


  this.registrationService.post(`abha/m2/v3/link/carecontextv3?hip-id=${hfrId}`,payload).subscribe({
      next: res => {
        if (res.status == 'OK') {
          this.toastr.info("Please Wait a Second"); setTimeout(() => this.toastr.clear(), 3000);
          if(res.data){
            this.hiType = 'DischargeSummary'
            setTimeout(() => {
              this.getcarecontextCallback(res.data)
              this.getLinkCareContext2(hfrId)
            }, 3000);
        
          // this.toastr.success(res.message)
          }

       

        } else {
          let errMsg: string = res.message;
          this.toastr.error(errMsg);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message);

      },
      complete: () => {
        // Any additional logic after patching values
      },
    });

  }
  getLinkCareContext2(hfrId){ //v3
     const uuId = uuid.v4();
    let payload =
    {
    "requestId": uuId,
    "abhaNumber": this.removeHyphen(this.data?.health_id_number),
    "abhaAddress":this.data?.health_id,
    "token": this.linkToken,
    "patient": [{
        "referenceNumber":this.beneficiary_id,
        "display": this.data?.is_self ? this.data.beneficiary_first_name + '-' +this.data.beneficiary_middle_name+ '-' + this.data.beneficiary_last_name :  this.divideName(this.data?.dependent_name || this.data?.fullname || this.data?.patient_name),
        "hiType":this.hiType,
        "count":1,
        "careContexts": [
            {
                "referenceNumber": this.data?.discharge_summary_number,
                "display": this.displayDate
            }
        ]
 } ]
}


  this.registrationService.post(`abha/m2/v3/link/carecontextv3?hip-id=${hfrId}`,payload).subscribe({
      next: res => {
        if (res.status == 'OK') {
          this.toastr.info("Please Wait a Second"); setTimeout(() => this.toastr.clear(), 3000);
          if(res.data){
            setTimeout(() => {
              
              this.getcarecontextCallback(res.data)
            }, 3000);
        
          // this.toastr.success(res.message)
          }

       

        } else {
          let errMsg: string = res.message;
          this.toastr.error(errMsg);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message);

      },
      complete: () => {
        // Any additional logic after patching values
      },
    });

  }
  


  getcarecontextCallback(requestId){
  
     this.registrationService.get(`registration/milestone2/getCallBack?requestId=${requestId}&api-type=ONLINK`).subscribe({
      next: res => {
        if (res.status == 'OK') {
           if(res.data?.response){
            if(this.hiType === 'WellnessRecord'){
              this.toastr.success(res.data?.response?.status)
              this.careContextLinkedApi()
            }
            else if(this.hiType === 'Invoice'){
              this.toastr.success(res.data?.response?.status)
              this.careContextLinkedApi2()
            }
            else if(this.hiType === 'HealthDocumentRecord'){
              this.toastr.success(res.data?.response?.status)
              this.careContextLinkedApi1()
            }
            else if(this.hiType === 'DischargeSummary'){
              this.toastr.success(res.data?.response?.status)
              this.closeModal()
            }
            else if(this.hiType === 'ImmunizationRecord'){
              this.toastr.success(res.data?.response?.status || 'Linked successfully')
              this.careContextLinkedApi3()
            }
            else {
              this.toastr.success(res.data?.response?.status || 'Linked successfully')
              this.closeModal()
            }
           }
        } else {
          let errMsg: string = res.message;
          this.toastr.error(errMsg);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message);
      },
      complete: () => {},
    });
  }


  // counting API Calls

  startApiCall() {

  if (this.apiCallCount === 0) {
    this.spinner.show();
  }

  this.apiCallCount++;
}

finishApiCall() {

  this.completedApiCount++;

  if (this.completedApiCount >= this.apiCallCount) {

    this.spinner.hide();

    this.apiCallCount = 0;
    this.completedApiCount = 0;
  }
}


careContextLinkedApi2(){  //Invoice
   this.registrationService.put(`poc-emr/basic-invoice/care-context-link//${this.data?.carecontext_reference}`,{}).subscribe({
      next: res => {
        if (res.status == 'OK') {
           if(res.data){
            this.closeModal()
           }

        } else {
          let errMsg: string = res.message;
          this.toastr.error(errMsg);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message);

      },
      complete: () => {
        // Any additional logic after patching values
      },
    });
}
careContextLinkedApi(){  //WellnessRecord
   this.registrationService.put(`registration/jwt/patient/carecontextlinked/${this.vitalsData?.id}`,{}).subscribe({
      next: res => {
        if (res.status == 'OK') {
           if(res.data){
            this.closeModal()
           }

        } else {
          let errMsg: string = res.message;
          this.toastr.error(errMsg);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message);

      },
      complete: () => {
        // Any additional logic after patching values
      },
    });
}
careContextLinkedApi1(){    //Document Upload
   this.registrationService.put(`registration/jwt/beneficiary/care-context-link/${this.data?.document_id}`,{}).subscribe({
      next: res => {
        if (res.status == 'OK') {
           if(res.data){
            this.closeModal()
           }

        } else {
          let errMsg: string = res.message;
          this.toastr.error(errMsg);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message);

      },
      complete: () => {
        // Any additional logic after patching values
      },
    });
}
careContextLinkedApi3(){    //Immunization
   this.registrationService.put(`poc-emr/jwt/doctor/poc/care-context-link/${this.data?.id}`,{}).subscribe({
      next: res => {
        if (res.status == 'OK') {
           if(res.data){
            this.closeModal()
           }

        } else {
          let errMsg: string = res.message;
          this.toastr.error(errMsg);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message);

      },
      complete: () => {
        // Any additional logic after patching values
      },
    });
}


}

  


    

